module.exports = {
      id: "sports-usage",
      viewBox: "0 0 26.459 26.453",
      url: "/" + "sprite-84df178c245af8be09420a4d0455d997.svg#sports",
      toString: function () {
        return this.url;
      }
    }